'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Row;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cell = require('./cell');

var _cell2 = _interopRequireDefault(_cell);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Row(props) {
  var data = props.data,
      columns = props.columns;
  var cells = columns.map(function (_ref, index) {
    var header = _ref.header,
        component = _ref.component,
        field = _ref.field;
    var key = 'cell-' + index;
    var value = data[field] || null;
    var isFirst = index === 0;
    return _react2.default.createElement(_cell2.default, {
      key: key,
      header: header,
      component: component,
      value: value,
      isFirst: isFirst
    });
  });
  return _react2.default.createElement('tr', {
    tabIndex: -1,
    'aria-selected': false,
    className: 'rainbow-table_body-row'
  }, cells);
}

Row.propTypes = {
  data: _propTypes2.default.object,
  columns: _propTypes2.default.array
};
Row.defaultProps = {
  data: [],
  columns: []
};